module.exports = __webpack_public_path__ + "static/media/description-24px.a77b597c.svg";